// �y�[�W���O���̍ő�\���s��
export const PAGE_LENGTH = 10; //API��NEXT ROWS��PAGE_LENGTH�AAPI��OFFSET���icurrentPage�{�P)�~PAGE_LENGTH
